import {Drawer, Select} from "antd";
import React from "react";
import {themes} from "../../../constants/themes";
import {primaryColors} from "../../../constants/colorScheme";

const {Option} = Select;

const ThemeMenu = ({theme, darkMode, primaryColor, collapsed, setCollapsed, changeTheme, changePrimaryColor}) => {
    return <Drawer className={darkMode && 'dark-mode'} title="Theme Settings" visible={!collapsed}
                   onClose={() => setCollapsed(true)}>
        Chose theme: &nbsp;
        <Select value={theme} style={{width: '100%'}} onChange={changeTheme} dropdownClassName={darkMode && 'dark-mode'}>
            {
                themes.map(({value, name}) => <Option key={value} value={value}>{name}</Option>)
            }
        </Select>

        <br/>
        <br/>
        Chose primary color: &nbsp;

        <Select value={primaryColor} style={{width: '100%'}} onChange={changePrimaryColor} dropdownClassName={darkMode && 'dark-mode'}>
            {
                primaryColors.map(({value, name}) => <Option key={value} value={value}>{name}</Option>)
            }
        </Select>

    </Drawer>;
};

export default ThemeMenu;